<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight]  current="Table Data List"></fury-breadcrumbs>
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name={{filterValue}} [columns]="columns" (filterChange)="onFilterChange($event)">
        <div style="position: relative;" class="filter">
            <button class="filter fury-column-filter" type="button" mat-icon-button (click)="showFilter()">
              <img src="../../../assets/img/filter.png" alt="filter"/>
            </button>
            <div class="filteringprt" *ngIf="isShowFilter">
              <form [formGroup]="filterForm">
              <h3 style="margin: 0;">Filter</h3>
              <mat-form-field appearance="outline">
                <mat-label>Search By</mat-label>
                <mat-select formControlName="searchBy">
                  <mat-option *ngFor="let item of serchByValue" [value]="item?.value">{{item.title}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Search Type</mat-label>
                <mat-select formControlName="searchType">
                  <mat-option *ngFor="let item of commonService.searchTypeValue" [value]="item?.value">{{item.title}}</mat-option>
                </mat-select>
              </mat-form-field>
              <div class="btnprt">
                <button mat-button class="can-button" (click)="showFilter()">Cancel</button>
                <button mat-button class="sub-button" (click)="filterChange()">Search</button>
              </div>
            </form>
            </div>
          </div>
        <div class="actions">
            <button class="create" type="button" [routerLink]="['/settings/compare-table/add-table-data']" mat-mini-fab color="primary">
                <mat-icon>add</mat-icon>
              </button>
        </div>
        <div class="table_container">
            <table [dataSource]="dataSource" #dataTable mat-table cdkDropList  (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="dragDisabled">
                <!-- actions Column -->
                <ng-container matColumnDef="actions" stickyEnd>
                    <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
                    <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                        <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                            (click)="$event.stopPropagation()">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                            <button mat-menu-item routerLink="/settings/compare-table/edit-table-data/{{row?.companyId}}">
                                <span>Edit</span>
                            </button>
                            <button mat-menu-item (click)="openDialog('delete', row?.companyId)">
                                <span>Delete</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>
                <ng-container matColumnDef="drag">
                    <th mat-header-cell class="image-cell" *matHeaderCellDef>Drag</th>
                    <td mat-cell class="image-cell" *matCellDef="let element">
                        <mat-icon class="dragCursor" (mousedown)="dragDisabled = false;"
                        >drag_handle</mat-icon>
                    </td>
                </ng-container>
                <ng-container matColumnDef="companyName">
                    <th mat-header-cell *matHeaderCellDef>Company Name</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.companyName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="bbbReview">
                    <th mat-header-cell *matHeaderCellDef>BBB Review</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.bbbReview}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="bbbAccredited">
                    <th mat-header-cell *matHeaderCellDef>BBB Accredited</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.bbbAccredited ? 'Yes' : 'No'}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="bbbRating">
                    <th mat-header-cell *matHeaderCellDef>BBB Rating</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.bbbRating}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="bbbComplaints">
                    <th mat-header-cell *matHeaderCellDef>BBB Complaints</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.bbbComplaints}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="copayment">
                    <th mat-header-cell *matHeaderCellDef>Copayment</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.copayment}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="workGuarantee">
                    <th mat-header-cell *matHeaderCellDef>Work Guarantee</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.workGuarantee}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="coverage">
                    <th mat-header-cell *matHeaderCellDef>Coverage</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.coverage}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="applianceCaps">
                    <th mat-header-cell *matHeaderCellDef>Appliances Payout</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.applianceCaps}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="systemsCaps">
                    <th mat-header-cell *matHeaderCellDef>Systems Payout</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.systemsCaps}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="maintenanceRecord">
                    <th mat-header-cell *matHeaderCellDef>Maintenance Record</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.maintenanceRecord ? 'Required' : 'Not Required'}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="startingPrice">
                    <th mat-header-cell *matHeaderCellDef>Starting Price</th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.startingPrice}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="isActive">
                    <th *matHeaderCellDef mat-header-cell>Status</th>
                    <td *matCellDef="let row" mat-cell>
                        <mat-slide-toggle [(ngModel)]="row.isActive" (change)="changeStatus($event, row)"></mat-slide-toggle>
                    </td>
                </ng-container>
                
                <tr *matHeaderRowDef="visibleColumns; sticky: true" mat-header-row></tr>
                <tr *matRowDef="let row; columns: visibleColumns"
                    class="clickable route-animations-elements" mat-row cdkDrag
                    [cdkDragData]="row">
                </tr>
                <div *cdkDragPlaceholder></div>
            </table>
        </div>
        
        <div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
            No Data found.
        </div>
          <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
          showFirstLastButtons
          [selectConfig] = "selectConfig"
          [ngClass]="{'mat-pegig': pageSize === 9999}"
          aria-label="Select page of periodic elements">
      </mat-paginator>
  
      </fury-list>
  
    </fury-page-layout-content>
  </fury-page-layout>
  




